import { Col, Container, Image, Row } from "react-bootstrap"
import bgHome from '../img/bgHome.png'
import { withTranslation } from "react-i18next"

function Statics({t}){
    return (
        <Container fluid>
            <Row>
                <Col xs="12" md="6" className="px-0" >                    
                    <div className="position-relative">
                        <div className="bg-info-1">
                            <div className="p-5">
                                <h3 className="text-white">{t('operador_dashboard_title')}</h3>
                                <p className="text-white my-4">{t('operador_dashboard_title1')}
                                </p>

                                {/* <h5 className="text-white">{t('resultado_mes')}</h5> */}
                            </div>
                        </div>
                        {/* <Row className="mt-m60">
                            <Col xs="12" md="6">
                                <Card className="m-3">
                                    <Card.Body>
                                        <label className="mb-0 text-secondary d-block">{t('citas_generadas')}</label>
                                        <span className="text-color-1 font-size-17rem font-weight-bold">28.324</span>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs="12" md="6">
                                <Card className="m-3">
                                    <Card.Body>
                                        <label className="mb-0 text-secondary d-block">{t('citas_canceladas')}</label>
                                        <span className="font-size-17rem font-weight-bold text-color-2">120</span>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs="12" md="6">
                                <Card className="m-3">
                                    <Card.Body>
                                        <label className="mb-0 text-secondary d-block">{t('nuevos_pacientes')}</label>
                                        <span className="text-color-1 font-size-17rem font-weight-bold">89 <Image src={up} fluid/></span>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs="12" md="6">
                                <Card className="m-3">
                                    <Card.Body>
                                        <label className="mb-0 text-secondary d-block">{t('siguimiento_pacientes')}</label>
                                        <span className="text-color-1 font-size-17rem font-weight-bold">46% <Image src={down} fluid/></span>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row> */}
                    </div>                    
                </Col>
                <Col xs="12" md="6" className="d-md-block d-none px-0">
                    <Image src={bgHome} fluid />
                </Col>
            </Row>
        </Container>
    )
}

export default withTranslation()(Statics)